import { render, staticRenderFns } from "./WalletIcon.vue?vue&type=template&id=5fccd542&scoped=true"
import script from "./WalletIcon.vue?vue&type=script&lang=js"
export * from "./WalletIcon.vue?vue&type=script&lang=js"
import style0 from "./WalletIcon.vue?vue&type=style&index=0&id=5fccd542&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fccd542",
  null
  
)

export default component.exports